import { angularServicesNames } from "@topline/services/angularServicesNames";
import { IdSvrAuthService } from "../../../auth/idSrvAuthService";
import { Gen } from "../../../Services/api";
import { ApiClient, MarketClient } from "../../../Services/apiService";

export class ForecastParametersProvider {
    static componentName = "ForecastParametersProvider";
    static $inject = [
        "$q",
        IdSvrAuthService.componentName,
        ApiClient.componentName,
        MarketClient.componentName,
        angularServicesNames.$translate
    ];

    private quantityType = { name: "Ilościowa", typeId: "volume" };
    private priceType = { name: "Średnia cena rynkowa", typeId: "value" };
    private dotType = { name: "DOT", typeId: "dot" };

    constructor(
        protected $q: ng.IQService,
        protected authService: IdSvrAuthService,
        protected apiClient: ApiClient,
        protected marketClient: MarketClient,
        protected $translate: ng.translate.ITranslateService
    ) {}

    getMyMarkets(dataSourceId: Gen.MarketType, budgetYear: number) {
        if (!dataSourceId) {
            return this.$q.resolve([]);
        }
        return this.marketClient.getMyMarkets(dataSourceId, budgetYear);
    }

    async getDataSources() {
        const permissions = this.authService.hasPermissions(
            "ForecastImsMarkets",
            "ForecastFileMarkets",
            "ForecastScoringCardsMarkets",
            "ForecastScoringCardsPolandMarkets"
        );

        let sources: any = [];
        if (permissions.ForecastImsMarkets) {
            sources.push({ name: "Ims", urlPart: "ims", displayName: this.$translate.instant("DATA_SOURCES.Ims") });
        }
        if (permissions.ForecastFileMarkets) {
            sources.push({
                name: "File",
                urlPart: "file",
                displayName: this.$translate.instant("DATA_SOURCES.File")
            });
        }
        if (permissions.ForecastScoringCardsMarkets) {
            sources.push({
                name: "ScoringCards",
                urlPart: "scoringCards",
                displayName: this.$translate.instant("DATA_SOURCES.ScoringCards")
            });
        }
        if (permissions.ForecastScoringCardsPolandMarkets) {
            sources.push({
                name: "ScoringCardsPoland",
                urlPart: "scoringCardsPoland",
                displayName: this.$translate.instant("DATA_SOURCES.ScoringCardsPoland")
            });
        }

        return sources;
    }

    getForecastMethods(dataSource: string) {
        return this.$q((resolve: any, reject: any) => {
            if (["ims"].includes(dataSource)) {
                resolve([
                    {
                        name: "Dla rynku (Mktsh)",
                        methodId: "mktsh",
                        types: [this.quantityType, this.priceType, this.dotType]
                    },
                    {
                        name: "Dla SKU",
                        methodId: "sku",
                        types: [this.quantityType]
                    }
                ]);
            } else if (["file"].includes(dataSource)) {
                resolve([
                    {
                        name: "Dla rynku (Mktsh)",
                        methodId: "mktsh",
                        types: [this.quantityType, this.priceType]
                    },
                    {
                        name: "Dla SKU",
                        methodId: "sku",
                        types: [this.quantityType]
                    }
                ]);
            } else if (["scoringCards", "scoringCardsPoland"].includes(dataSource)) {
                resolve([
                    {
                        name: "Fazowanie",
                        methodId: "chamfering",
                        types: [this.quantityType]
                    }
                ]);
            } else {
                reject();
            }
        });
    }

    getBrands(marketId: number) {
        return this.apiClient.getBrandsByMarket(marketId);
    }

    getForecastDefaults() {
        return this.apiClient.getPeriodsConfiguration().then(config => {
            return {
                defaultForecastPeriod: config.forecastDurationInYears,
                defaultHistoricalDataPeriod: config.historicalDataDurationInYears,
                forecastStartDate: new Date(config.forecastStartDate)
            };
        });
    }
}

angular.module("topline.services").service(ForecastParametersProvider.componentName, ForecastParametersProvider);
